import { SET_VEHICLE_DATA, FETCH_VEHICLE_DATA, SET_SEARCH_TEXT, SET_WALLET_BALANCE } from './constants';

const initialState = {
  loading: false,
  loaded: false,
  data: {},
};

const fasTag = (state: any = initialState, action: any) => {
  switch (action.type) {
    case FETCH_VEHICLE_DATA:
      return {
        ...state,
        loading: true,
        loaded: action.data.noReset ? true : false,
      };
    case SET_VEHICLE_DATA:
      let list: Array<object> = [];
      if (action.data.noReset) {
        if (state.data.list && state.data.list.length) {
          list = [...list, ...state.data.list];
        }
      }
      if (action.data.list && action.data.list.length) {
        list = [...list, ...action.data.list];
      }
      return {
        ...state,
        data: { ...action.data, list },
        loading: false,
        loaded: true,
      };
    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.data,
      };
    case SET_WALLET_BALANCE:
      return {
        ...state,
        balance: action.data || '',
      };
    default:
      return state;
  }
};

export default fasTag;
